import { jsx as _jsx } from "react/jsx-runtime";
const LinkWrapper = (props) => {
    const { children, href, ...anchorProps } = props;
    const pathname = typeof href === 'object' ? href.pathname : href;
    return (_jsx("a", { ...anchorProps, href: pathname, children: children }));
};
export default LinkWrapper;
